import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {DateFormatService} from 'dmmp-services'

@Component({
  selector: 'dmmp-website-trending-articles',
  templateUrl: './website-trending-articles.component.html'
})
export class WebsiteTrendingArticlesComponent implements OnInit {
  @Input() identifier
  @Input() module
  @Input() articlesList
  @Input() isDate = true
  @Input() quantityDescription = 120
  @Output() page = new EventEmitter()

  constructor(public dateFormat: DateFormatService) {
  }

  ngOnInit() {
  }
}
